import WarningsGroup from "./WarningsGroup";
import map from "../../app/map";
import rootScope from "../../app/rootScope";
import warningshtml from "../../../../maps-frontend/modules/templates/plugins/warnings/warnings.pug";
import broadcast from "../../app/broadcast";
import render from "../../app/render";


let warnings = null;


export const plugincode={html:warningshtml({
        domain: rootScope.resourcesServer
    })};

export default {
    redraw: function () {
    },
    onopen: function (params) {

        if( ! warnings ) {
            warnings = new WarningsGroup(map);
            warnings.load().then(() => {
                render.emit("updateBasemap", {coverWholeMap:false, hasSea: false, insideBounds:false});
                broadcast.emit("tileLayerOpened");
                broadcast.emit("redrawFinished");
            })

        }else {
            warnings.show();
            warnings.enableEvents();
            broadcast.emit("redrawFinished");
        }

    },
    paramsChanged: function (params){
    },
    onclose: function () {
        warnings.disableEvents();
        warnings.hide();
    }
}
